export default __webpack_public_path__ + "static/media/img-slider-smart-signage-1.d93a8cf3.png";